import(/* webpackMode: "eager" */ "/var/www/heizos-build/src/app/installer/page.tsx");
